import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab3 = ({
  IdData,
  TaxCategory,
  TaxID,
  TaxWithholdingCategory,
  GSTIN_UIN,
  PAN,
  GSTCategory,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Purchasing Details</p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="TaxID"
              label="Tax ID"
              style={{ height: "30px" }}
              value={TaxID.TaxID}
              onChange={(e) => TaxID.setTaxID(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={TaxCategory.TaxCategory_list}
              style={{
                height: "30px",
                border: TaxCategory.Error ? "1px solid red" : "",
              }}
              label="Tax Category"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={TaxCategory.select_TaxCategory}
              onChange={(val) => TaxCategory.setselect_TaxCategory(val)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={TaxWithholdingCategory.TaxWithholdingCategory_list}
              style={{
                height: "30px",
                border: TaxWithholdingCategory.Error ? "1px solid red" : "",
              }}
              label="Tax With holding Category"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={TaxWithholdingCategory.select_TaxWithholdingCategory}
              onChange={(val) =>
                TaxWithholdingCategory.setselect_TaxWithholdingCategory(val)
              }
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Tax Details</p>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="GSTIN_UIN"
              label="GSTIN / UIN"
              style={{ height: "30px" }}
              value={GSTIN_UIN.GSTIN_UIN}
              onChange={(e) => GSTIN_UIN.setGSTIN_UIN(e.target.value)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">
            <Input
              id="PAN"
              label="PAN"
              style={{ height: "30px" }}
              value={PAN.PAN}
              onChange={(e) => PAN.setPAN(e.target.value)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={[
                { name: "Registered Regular" },
                { name: "Registered Composition" },
                { name: "Unregistered" },
                { name: "SEZ" },
                { name: "Overseas" },
                { name: "Deemed Export" },
                { name: "UIN Holders" },
                { name: "Tax Deductor" },
                { name: "Tax Collector" },
                { name: "Input Service Distributor" },
              ]}
              style={{
                height: "30px",
                border: GSTCategory?.Error ? "1px solid red" : "",
              }}
              label="GST Category"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={GSTCategory?.GSTCategory || ""}
              onChange={(value) => GSTCategory?.setGSTCategory?.(value)}
            />
          </div>
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Supplier" docname={IdData} />
      </div>

    </>
  );
};

export default Tab3;
